import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "add-padding" }
const _hoisted_6 = ["href"]

import { toRefs, onMounted } from 'vue';

// Define Component Input Properties

export default /*#__PURE__*/_defineComponent({
  __name: 'Book-Card',
  props: {
    bookTitle: String,
    bookImage: String,
    bookUrl: String
},
  setup(__props) {

const props = __props;



// get back slide card info
const { bookTitle, bookImage, bookUrl } = toRefs(props);

// when script loads initially set the first one to active
onMounted(() => {
    const topElement = document.getElementById('carousel-inner');
    topElement.children[0].classList.add('active');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row",
      alt: _unref(bookTitle)
    }, [
      _createElementVNode("img", {
        src: _unref(bookImage),
        class: "img-responsive",
        width: "157",
        height: "243"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: _unref(bookUrl),
          class: "col-xs-12 btn btn-lg btn-prime-1"
        }, "Buy Now", 8, _hoisted_6)
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})